import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "alt"]

import { UiButton } from '@huntflow/ui';
import { computed } from 'vue';
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import { AuthType } from '../../api/integration';
import { appConfig } from '../../lib/config/app-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'integration',
  props: {
    type: {},
    isConference: { type: Boolean },
    loading: { type: Boolean },
    error: { default: null },
    displayName: { default: null },
    isConnected: { type: Boolean }
  },
  emits: ["disconnect", "connect"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const icons: {
  [key: string]: {
    icon: string;
    fallback: string;
  };
} = {
  RABOTARU: {
    icon: require('./rabotaru.svg'),
    fallback: '#3495DB'
  },
  LI: {
    icon: require('./li.svg'),
    fallback: '#2D75B6'
  },
  AH: {
    icon: appConfig.get('instanceRegion') === 'RU' ? require('./matchy.svg') : require('./ah.svg'),
    fallback: '#EAEAEA'
  },
  HH: {
    icon: require('./hh.svg'),
    fallback: '#D6001D'
  },
  VK: {
    icon: require('./vk.svg'),
    fallback: '#55759F'
  },
  MK: {
    icon: require('./mk.svg'),
    fallback: '#759AA8'
  },
  SJ: {
    icon: require('./sj.svg'),
    fallback: '#4BA789'
  },
  ZPRU: {
    icon: require('./zpru.svg'),
    fallback: '#EABB52'
  },
  ZPRUHH: {
    icon: require('./zpru.svg'),
    fallback: '#EABB52'
  },
  PODBOR: {
    icon: require('./podbor.svg'),
    fallback: '#4687F0'
  },
  AVITO: {
    icon: require('./avito.svg'),
    fallback: '#FFF'
  },
  GMATE: {
    icon: require('./gmate.svg'),
    fallback: '#FFE54B'
  },
  ZOOM: {
    icon: require('./zoom.svg'),
    fallback: '#4A8CFF'
  },
  OUTLOOK365: {
    icon: require('./outlook365.svg'),
    fallback: '#FFF'
  },
  GOOGLE: {
    icon: require('./googlemeet.svg'),
    fallback: '#FFF'
  },
  RABOTABY: {
    icon: require('./rabotaby.svg'),
    fallback: '#E80200'
  },
  YANDEX_OAUTH2: {
    icon: require('./yandex.telemost.svg'),
    fallback: '#0E1217'
  },
  MTSLINK: {
    icon: require('./mtslink.svg'),
    fallback: '#FF0131'
  },
  KONTUR_TALK: {
    icon: require('./kontur-talk.svg'),
    fallback: '#51ADFF'
  }
};

const i18n = useI18N();

const title = computed(() => {
  let finalType = __props.type;
  if (__props.type === AuthType.ah && appConfig.get('instanceRegion') === 'RU') {
    finalType = 'MATCHY';
  }
  return __props.isConference
    ? i18n(`auth_type.conference.${finalType}`)
    : i18n(`auth_type.${finalType}`);
});

const connect = () => {
  emit('connect', __props.type);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.method)
  }, [
    (icons[__props.type].icon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: icons[__props.type].icon,
          alt: title.value,
          class: _normalizeClass(_ctx.$style.icon),
          style: _normalizeStyle({ background: icons[__props.type].fallback })
        }, null, 14, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title),
      "data-qa": "integration-title"
    }, _toDisplayString(title.value), 3),
    _renderSlot(_ctx.$slots, "connection", { dataQa: "integration-connect-button" }, () => [
      (!__props.isConnected)
        ? (_openBlock(), _createBlock(_unref(UiButton), {
            key: 0,
            "data-qa": "integration-connect-button",
            loading: __props.loading,
            size: "s",
            type: "secondary",
            onClick: connect
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n)('connect')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    (__props.isConnected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            "data-qa": "account",
            class: _normalizeClass(_ctx.$style.account)
          }, _toDisplayString(__props.displayName), 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.disconnect),
            "data-qa": "integration-disconnect-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('disconnect', __props.type)))
          }, _toDisplayString(_unref(i18n)('disconnect')), 3)
        ], 64))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.$style.error)
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})